import React from 'react';
import type {NoProps} from 'types';
import type {CodeListId} from 'services/codelists/types';
import {useLocalization} from 'localization';
import {CodeListsGate} from 'services/codelists';
import {Scene} from 'components';
import {ReceiveEans} from './components/ReceiveEans';

type Props = NoProps;

const codelists: CodeListId[] = ['PRODUCT_FORM'];
export const ReceiveScene: React.FC<Props> = () => {
  const {t} = useLocalization();
  return (
    <Scene browserTitle={t('appbar.receive')}>
      <Scene.Header title={t('appbar.receive')} />
      <Scene.Content>
        <CodeListsGate codeLists={codelists}>
          <ReceiveEans />
        </CodeListsGate>
      </Scene.Content>
    </Scene>
  );
};
